import { eventConfig } from './eventConfig'
import { INVITE_STORY_TEXT, INVITE_GIFT_TEXT } from './inviteTexts'
import type { SiteContent } from './types'

/**
 * Default content structure matching SiteContent interface.
 * Used as fallback when database content is unavailable.
 */
export const contentDefaults: SiteContent = {
  event: {
    coupleNames: eventConfig.coupleNames,
    invitationText: 'laden herzlich ein zur',
    eventTitle: eventConfig.eventTitle,
    eventDate: eventConfig.eventDate,
  },
  location: {
    name: eventConfig.locationName,
    addressLine1: eventConfig.locationAddressLine1,
    addressLine2: eventConfig.locationAddressLine2,
  },
  contact: {
    primaryPhoneLabel: eventConfig.primaryPhoneLabel,
    primaryPhoneNumber: eventConfig.primaryPhoneNumber,
    secondaryPhoneLabel: eventConfig.secondaryPhoneLabel,
    secondaryPhoneNumber: eventConfig.secondaryPhoneNumber,
  },
  invitation: {
    storyText: INVITE_STORY_TEXT,
    giftText: INVITE_GIFT_TEXT,
  },
  timeline: [
    {
      time: '14:00 Uhr',
      description: 'Freie Trauung unter der Walnuss',
    },
    {
      time: '15:00 Uhr',
      description: 'Sektempfang auf der Zeltterrasse',
    },
    {
      time: '15:30 Uhr',
      description: 'Fingerfood + Hochzeitstorte zum Sektempfang',
    },
    {
      time: '16:00 Uhr',
      description: 'Burgführung',
    },
    {
      time: '18:00 Uhr',
      description: 'Abendessen',
    },
    {
      time: '00:00 Uhr',
      description: 'Mitternachtssnack',
    },
  ],
  rsvp: {
    descriptionMultiple: 'Teilt uns bitte mit, ob Ihr an unserer Hochzeit teilnehmen mögt.',
    descriptionSingle: 'Bitte geben Sie uns Bescheid, ob Sie an unserer Hochzeit teilnehmen können.',
    dietaryTitle: 'Besondere Ernährungswünsche',
    dietaryVegan: 'Vegan',
    dietaryGlutenFree: 'Glutenfrei',
    dietaryLactoseFree: 'Laktosefrei',
    dietaryAllergiesLabel: 'Allergien',
    dietaryAllergiesPlaceholder: 'z.B. Nüsse, Meeresfrüchte',
    dietaryMiscLabel: 'Sonstiges',
    dietaryMiscPlaceholder: 'Weitere Ernährungswünsche',
    additionalGuestsTitle: 'Zusätzliche Gäste',
    noAdditionalGuests: 'Noch keine zusätzlichen Gäste hinzugefügt',
    addPlusOne: '+1 hinzufügen',
    addChild: 'Kind hinzufügen',
    emailLabel: 'E-Mail-Adresse (optional)',
    emailPlaceholder: 'Für eventuelle Updates',
    emailDescription: 'Falls wir Dich über Neuigkeiten informieren möchten',
    commentsLabel: 'Kommentare',
    commentsPlaceholder: 'Weitere Anmerkungen oder Fragen',
  },
  photos: {
    description:
      'Teilt jene Augenblicke mit uns, die diese festliche Hochzeit besonders wertvoll machen. Ladet jene Fotos empor, die euch besonders am Herzen liegen und die Erinnerung an diesen festlichen Tag bewahren.',
    deleteModalTitle: 'Foto löschen',
    deleteModalText:
      'Möchten Sie dieses Foto wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteButton: 'Löschen',
  },
  ui: {
    Willkommen: 'Willkommen',
    'PIN eingeben': 'PIN eingeben',
    Weiter: 'Weiter',
    Rückmeldung: 'Rückmeldung',
    Speichern: 'Speichern',
    Abbrechen: 'Abbrechen',
  },
}

